import React from 'react';

import BooleanIcon from 'components/BooleanIcon';

import './styles.css';

const IsAdmin = ({isAdmin}) => (
  <div className="IsAdmin">
    <div className="label">is admin</div>
    <BooleanIcon className="value" value={isAdmin} />
  </div>
);

export default IsAdmin;
